import { Label, RadioButton } from '@nokia-csf-uxr/ccfk';
import FieldSet, { FieldSetContent, Legend } from '@nokia-csf-uxr/ccfk/FieldSet';
import { RadioButtonLabelContent } from '@nokia-csf-uxr/ccfk/RadioButton';
import React from 'react';
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import ValueInput from '../../ValueInput';
import Form from 'react-bootstrap/esm/Form';
import Row from 'react-bootstrap/esm/Row';
import Container from 'react-bootstrap/esm/Container';
import Col from 'react-bootstrap/esm/Col';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkReferenceContext, DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * RainOutagePred component
 */
export default class RainOutagePred extends WLDInputComponent {

    constructor(props: {band: number}) {
        super(props);
    }

    /**
     * Function is called when the methodology of annual outage is changed
     * @param link 
     * @param newData 
     */
    onChangeMethodology(link:Readonly<any>, newData: {}) {
        link.define("annualOutageNorm", newData)
    }

    onChangeTempUnit(link:Readonly<any>, newData: {}) {
        link.define("tempUnit", newData)
    }

    /**
     * Function is called when the temperature is changed
     * @param link  user's data
     * @param newData New data which has been selected
     */
    onAvgTemperatureChange(link:Readonly<any>, newData: {}) {
        link.define("avg_tmp", newData)
    }


    render() {
        return (
        <Container>
            { this.props.band == 1 ?
                <SingleBandLinkUserContext.Consumer>
                    {(link) => (
                    <>
                    <SingleBandLinkReferenceContext.Consumer>
                        {(linkRef) => (
                            <>
                            <Row className='mb-2'>
                                <Form.Label>Methodology</Form.Label>
                                <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                    { linkRef?.annualOutageNorms?.map((annualOutageNorm: {idAnnualOut: number, name: string}, index: any) =>
                                        <Form.Check
                                            type="radio"
                                            label={ annualOutageNorm.name }
                                            className={linkRef?.distanceUnits.length == (index+1) ? "ms-sm-3" : ""}
                                            checked={link?.annualOutageNorm?.idAnnualOut === annualOutageNorm.idAnnualOut}
                                            onChange={() => this.onChangeMethodology(link, {index: index, ...annualOutageNorm}) }
                                        />
                                    ) }
                                </FieldSetContent>
                            </Row>
                                { link?.annualOutageNorm?.idAnnualOut == 2 ?
                                <Row>
                                    <Col xs={6}>
                                        <Form.Label>Average temperature</Form.Label>
                                        <ValueInput valueType="integer" value={link?.avg_tmp ? link.avg_tmp : 0}
                                            onChange={(data: any) => {
                                                link.define("avg_tmp", data)                              
                                            }}  
                                            onBlur={(data: any, error: any) => {}}></ValueInput>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Label>Unit</Form.Label>
                                        <FieldSetContent role="radiogroup" className="standard-FieldSetContent center-radiobnt">
                                            { linkRef?.tempUnits?.map((tempUnits: {idTempUnit: number, shortname: string}, index: any) =>
                                                <Form.Check
                                                    type="radio"
                                                    label={ tempUnits.shortname }
                                                    className={linkRef?.distanceUnits.length == (index+1) ? "ms-sm-3" : ""}
                                                    checked={link?.tempUnit?.idTempUnit === tempUnits.idTempUnit}
                                                    onChange={(e) => this.onChangeTempUnit(link, {index: index, ...tempUnits}) }
                                                />
                                            ) }
                                        </FieldSetContent>
                                    </Col>
                                </Row>
                                : <></> }
                            </> 
                        )}
                    </SingleBandLinkReferenceContext.Consumer>
                    </>
                    )}
                </SingleBandLinkUserContext.Consumer>
            :
                <DualBandLinkUserContext.Consumer>
                    {(link) => (
                    <>
                    <DualBandLinkReferenceContext.Consumer>
                        {(linkRef) => (
                            <>
                            <Row className='mb-2'>
                                <Form.Label>Methodology</Form.Label>
                                <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                    { linkRef?.annualOutageNorms?.map((annualOutageNorm: {idAnnualOut: number, name: string}, index: any) =>
                                        <Form.Check
                                            type="radio"
                                            label={ annualOutageNorm.name }
                                            className={linkRef?.distanceUnits.length == (index+1) ? "ms-sm-3" : ""}
                                            checked={link?.annualOutageNorm?.idAnnualOut === annualOutageNorm.idAnnualOut}
                                            onChange={() => this.onChangeMethodology(link, {index: index, ...annualOutageNorm}) }
                                        />
                                    ) }
                                </FieldSetContent>
                            </Row>
                                { link?.annualOutageNorm?.idAnnualOut == 2 ?
                                <Row>
                                    <Col xs={6}>
                                        <Form.Label>Average temperature</Form.Label>
                                        <ValueInput valueType="integer" value={link?.avg_tmp ? link.avg_tmp : 0}
                                            onChange={(data: any) => {
                                                link.define("avg_tmp", data)                              
                                            }}  
                                            onBlur={(data: any, error: any) => {}}></ValueInput>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Label>Unit</Form.Label>
                                        <FieldSetContent role="radiogroup" className="standard-FieldSetContent center-radiobnt">
                                            { linkRef?.tempUnits?.map((tempUnits: {idTempUnit: number, shortname: string}, index: any) =>
                                                <Form.Check
                                                    type="radio"
                                                    label={ tempUnits.shortname }
                                                    className={linkRef?.distanceUnits.length == (index+1) ? "ms-sm-3" : ""}
                                                    checked={link?.tempUnit?.idTempUnit === tempUnits.idTempUnit}
                                                    onChange={(e) => this.onChangeTempUnit(link, {index: index, ...tempUnits}) }
                                                />
                                            ) }
                                        </FieldSetContent>
                                    </Col>
                                </Row>
                                : <></> }
                            </> 
                        )}
                    </DualBandLinkReferenceContext.Consumer>
                    </>
                    )}
                </DualBandLinkUserContext.Consumer>
            }
        </Container>
        );
    }

}